import smallLogo from "../images/smallLogo.svg"

// Logo "The Scan" conforme a la maquette Figma (glyphe R + wordmark),
// remplace l'ancien logo "Rising up" complet.
const LogoDashboard = (props) => (
  <span style={{display:"inline-flex", alignItems:"center", gap:"10px"}} {...props}>
    <img alt="" src={smallLogo} style={{height:"24px", display:"block"}} />
    <span style={{fontSize:"19px", fontWeight:500, color:"black", whiteSpace:"nowrap", lineHeight:1}}>
      The Scan
    </span>
  </span>
);

export default LogoDashboard;
